export default __webpack_public_path__ + "static/media/Lip_4_F.6ce607e7.svg";